/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
function i(i){const n=[];return i&&(n.push("applyProjection"),1===i.spacing[0]&&n.push("lookupProjection")),n}function n(i,n,e){const u=!e.capabilities.textureFloatLinear,t=[];return"cubic"===i?t.push("bicubic"):"bilinear"===i&&(n?(t.push("bilinear"),t.push("nnedge")):u&&t.push("bilinear")),t}export{n as getInterpolationDefines,i as getProjectionDefines};
